/*
  Catalog-price sync for Searchanise-rendered result cards.

  Searchanise indexes products with base storefront prices at feed time — for
  logged-in B2B customers those prices don't match the catalog price shown on
  the PDP. This script hits the Section Rendering API for each card
  (/products/{handle}?sections=snize-catalog-price) which Shopify renders with
  the customer's session cookie, so the response carries the buyer-aware price.
  We parse it out and replace the `.snize-price-list` innerHTML in place.

  Only runs when the current customer is logged into a B2B company; guests get
  the same base prices Searchanise has always rendered.

  Concurrency-capped at CONCURRENCY parallel fetches; results are sessionStorage-
  cached per handle so pagination + facet changes don't re-hit the network.
*/
(function () {
  var STATE = window.__CCTN_CONTRACT_BADGE;
  if (!STATE || !STATE.customerHasCompany) return;

  var CONCURRENCY = 6;
  var CACHE_KEY   = 'cctn_snize_price_cache_v1';
  var MARK        = 'data-cctn-price-synced';
  var IN_FLIGHT   = new Set();

  // sessionStorage-backed cache: {handle: {price, formatted, compareAt, compareAtFormatted, available, at}}
  var cache = (function () {
    try { return JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); }
    catch (e) { return {}; }
  })();
  function persistCache() {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
  }

  function handleFromHref(href) {
    if (!href) return null;
    var url = href.split('#')[0].split('?')[0].replace(/\/$/, '');
    var parts = url.split('/');
    return parts.length ? parts[parts.length - 1] : null;
  }

  function parseSectionHTML(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector('#snize-catalog-price-data');
    if (!node) return null;
    return {
      price:               parseFloat(node.getAttribute('data-price') || '0') / 100,
      formatted:           node.getAttribute('data-price-formatted') || '',
      compareAt:           parseFloat(node.getAttribute('data-compare-at') || '0') / 100,
      compareAtFormatted:  node.getAttribute('data-compare-at-formatted') || '',
      available:           node.getAttribute('data-available') === 'true'
    };
  }

  function fetchPrice(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var url = '/products/' + encodeURIComponent(handle) + '?sections=snize-catalog-price';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return null;
        var html = data['snize-catalog-price'];
        if (!html) return null;
        var parsed = parseSectionHTML(html);
        if (!parsed) return null;
        cache[handle] = parsed; persistCache();
        return parsed;
      })
      .catch(function () { return null; });
  }

  function renderPriceHTML(data) {
    if (!data || !data.formatted) return null;
    // Zero catalog price is a signal to keep Searchanise's own "Request a Quote"
    // rendering — don't overwrite it.
    if (data.price === 0) return null;
    var main = '<span class="snize-price money">' + data.formatted +
               '<span class="snize-highlight-saving-text"></span></span>';
    if (data.compareAt > data.price) {
      main = '<span class="snize-price money">' + data.formatted + '</span>' +
             '<span class="snize-compare-price money">' + data.compareAtFormatted + '</span>';
    }
    return main;
  }

  function replaceCardPrice(card, data) {
    var priceEl = card.querySelector('.snize-price-list');
    if (!priceEl) return;
    var newHTML = renderPriceHTML(data);
    if (!newHTML) return;
    priceEl.innerHTML = newHTML;
  }

  function processCard(card) {
    if (!card || card.getAttribute(MARK)) return;
    var link = card.querySelector('a.snize-view-link') || card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var handle = handleFromHref(link.getAttribute('href'));
    if (!handle) return;
    card.setAttribute(MARK, '1');
    if (IN_FLIGHT.size >= CONCURRENCY) {
      // Backpressure — undo the mark so a later scan retries this card.
      card.removeAttribute(MARK);
      return;
    }
    IN_FLIGHT.add(handle);
    fetchPrice(handle).then(function (data) {
      IN_FLIGHT.delete(handle);
      if (data) replaceCardPrice(card, data);
    });
  }

  function scan() {
    document.querySelectorAll('.snize-product:not([' + MARK + '])').forEach(processCard);
    document.querySelectorAll('.snize-search-preview-result:not([' + MARK + '])').forEach(processCard);
    document.querySelectorAll('.snize-result:not([' + MARK + '])').forEach(processCard);
  }

  var observer = new MutationObserver(function () { scan(); });
  observer.observe(document.body, { childList: true, subtree: true });

  var pollId = setInterval(scan, 700);
  window.addEventListener('beforeunload', function () { clearInterval(pollId); observer.disconnect(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
